<template>
  <b-card class="ba-h-full ba-overflow-auto">
    <button @click="visible = !visible">Open File History</button>
    <br/>
    <button @click="fileHistoryDialogVisible = true">
      Open File History Dialog
    </button>

    <vis-file-history-dialog
      :visible.sync="fileHistoryDialogVisible"
      :link="link"
      :close-on-restored="false"
    />

    <vis-modal
      :visible="visible"
      @hide="visible = false"
      scrollable
      title="История редактирования"
    >
      <ul>
        <li
          v-for="(item, index) in items"
          :key="index"
          class="ba-relative ba-mb-6 last:ba-mb-0 ba-pl-8 sm:ba-pl-12"
        >
          <!-- timeline -->
          <div
            class="ba-absolute ba-left-0 sm:ba-left-4 ba-flex ba-flex-col ba-items-center ba-mt-7"
            :class="{ 'ba-h-full': index !== items.length - 1 }"
          >
            <div
              class="ba-flex ba-flex-shrink-0 ba-w-2.4 ba-h-2.4 ba-border ba-border-accent ba-rounded-full"
              :class="{ 'ba-bg-accent': index !== 0 }"
            >
              <span
                v-if="index === 0"
                class="ba-w-1.4 ba-h-1.4 ba-m-auto ba-bg-accent ba-rounded-full"
              />
            </div>
            <div
              v-if="index !== items.length - 1"
              class="ba-relative ba-right-px ba-top-3 ba-flex-1 ba-border-l ba-border-accent"
            />
          </div>
          <!-- ============================== -->
          <div class="ba-px-6 ba-py-4 ba-bg-background-light ba-rounded-sm">
            <header
              class="ba-flex ba-justify-between 2md:ba-items-center ba-mb-4"
            >
              <div class="ba-flex ba-items-center">
                <div
                  class="ba-flex ba-justify-center ba-items-center ba-flex-shrink-0 ba-w-10 ba-h-10 ba-bg-background-blocks ba-rounded-full ba-overflow-hidden ba-select-none"
                >
                  <img
                    v-if="item.photo"
                    :src="`/img/avatars/${item.photo}.jpg`"
                    :alt="item.name"
                    width="40"
                    height="40"
                    class="ba-w-full ba-h-full ba-object-cover"
                  />
                  <span
                    v-else
                    class="ba-m-auto ba-uppercase ba-text-text-blue-grey"
                  >
                    {{ item.initials }}
                  </span>
                </div>
                <div class="ba-ml-2 ba-font-medium">
                  <p class="ba-leading-none">{{ item.name }}</p>
                  <p class="ba-whitespace-no-wrap ba-text-text-blue-grey">
                    <span class="ba-mr-1">{{ item.date }}</span>
                    <span>{{ item.time }}</span>
                  </p>
                </div>
              </div>
              <p
                v-if="item.current"
                class="ba-ml-2 ba-text-right ba-leading-tight ba-font-semibold ba-text-text-blue-grey"
              >
                Текущая версия
              </p>
            </header>
            <!-- document -->
            <div
              class="ba-flex ba-flex-col 2lg:ba-flex-row 2md:ba-ml-12 ba-px-6 ba-py-3 ba-bg-white ba-rounded-sm"
            >
              <p
                class="ba-flex ba-items-center 2lg:ba-mr-4 ba-mb-3 2lg:ba-mb-0"
              >
                <component
                  :is="`vis-icon-file-${item.fileType}`"
                  class="ba-flex-shrink-0 ba-w-5 ba-mr-4"
                />
                <span class="ba-text-base ba-leading-tight">{{
                  item.fileName
                }}</span>
              </p>
              <!-- controls -->
              <div
                class="ba-flex ba-flex-col xs:ba-flex-row ba-justify-center ba-items-center 2lg:ba-ml-auto"
              >
                <button
                  v-if="item.restore"
                  type="button"
                  class="ba-flex ba-items-center ba-mb-2 xs:ba-mb-0 xs:ba-mr-2 ba-px-5 ba-py-3 ba-whitespace-no-wrap ba-text-accent ba-border ba-border-accent ba-rounded-full ba-select-none ba-duration-150 hover:ba-text-white hover:ba-bg-accent"
                >
                  <vis-icon-history class="ba-w-4 ba-h-4" />
                  <span class="ba-ml-2 ba-leading-none ba-tracking-wide"
                    >Восстановить</span
                  >
                </button>
                <button
                  type="button"
                  class="ba-flex ba-items-center sm:ba-ml-4 ba-px-5 ba-py-3 ba-whitespace-no-wrap ba-text-white ba-bg-accent ba-border ba-border-accent ba-rounded-full ba-select-none ba-duration-150 hover:ba-bg-primary hover:ba-border-primary"
                >
                  <vis-icon-eye class="ba-w-4 ba-h-4" />
                  <span class="ba-ml-2 ba-leading-none ba-tracking-wide"
                    >Просмотреть</span
                  >
                </button>
              </div>
            </div>
            <!-- ============================= -->
          </div>
        </li>
      </ul>
    </vis-modal>
  </b-card>
</template>

<script>
export default {
  name: "v-file-history-page",
  data() {
    return {
      visible: false,
      fileHistoryDialogVisible: false,
      link:
        "xot3mYOi8QO4hrlU6hOpZh9XOAp1xBPCjK3U2TA0X7Tlkh_wRdHr5oXt3eiUKrHBmVHTFKQismgGKgxTrMUEgKJNFfmx8HP6O4tSycsM5H68j52Ot3cg3TTIQuDde9YBtLaALZiKxC1A3CU_Gx4uPEDiskYrbLr04_EckXlI7R6bASyNuUyx2hmc57LHxlJjW2aLOFtoFojdJ1XvAv7cOoyoY6oyhsV-R6dSBAPpnQ-xFAx6oHzuwgSOqoiJ7_Xt2wvC6bjSShy6Ki1VW-eMZEljbqxFKOP-Ikui-sYL1US-WPqifgXZJ1QqA-DVevQ6EveUcZ-k7CesJNcagOCuV2NyCrLVaQWKiJMa5o6ESMXyHzOuptnoi1kK_RCd3BgZWL22Iox9VxTDAfdcvYZH5U0aUTireUt1Cv5UtEu31o7CXeYncxF4_eAL1IE4uk2hfv74GiudunKZascFF6HpvacNqLFLjI4OSNAkhbdOKk7APvvh-ir7OfSxmGx_ms8dRX5fs32jvxwpTSDcroAW9-MeMWzSbFtYzJDDnFFDs_b8zNQOj8fTnlX5cUzi2GjlGZW4vUwx9dzDz_5iyf0tWtzFfr8wOJ8zdTwY2HRaT9nQykgMkVbP9kkz2ygiwlxjnMrujS-7r_C7ENeepThNTgzuPvw4venR1B5S5w1XWwk1EC9OfiOk_r5n1Z0-wfIHwZOxKpU6TXdVBXE-Kv8WXFcaEaGZy-YDA09Lt82p-6i3YG-T4XDHBp2Jgg2OPJszXXv76vy24hTLVxoRkvYTjA",
      items: [
        {
          name: "Горин Игорь Андреевич",
          photo: "8",
          initials: "ГИ",
          date: "15.03.2021",
          time: "15:45",
          fileName: "Расчет бюджета мероприятия.pdf",
          fileType: "pdf",
          current: true,
          restore: false
        },
        {
          name: "Горин Игорь Андреевич",
          // photo: '8',
          initials: "ГИ",
          date: "15.03.2021",
          time: "15:45",
          fileName: "Расчет бюджета мероприятия.doc",
          fileType: "doc",
          restore: true
        },
        {
          name: "Горин Игорь Андреевич",
          photo: "8",
          initials: "ГИ",
          date: "15.03.2021",
          time: "15:45",
          fileName: "Расчет бюджета мероприятия.pdf",
          fileType: "pdf",
          restore: true
        }
      ]
    };
  }
};
</script>
